/**
 * Duration formatting utilities
 */

// Platform-independent utilities — re-exported from shared
export {
  sumSegmentMs,
  formatDurationCompact,
  formatMs,
  formatOvertimeHours,
} from '@aegislab/shared';

/**
 * Format milliseconds as Korean duration (e.g. "3시간 25분")
 * Used in daily attendance cards and detail views.
 */
export function formatDurationKo(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '0분';
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  if (h === 0) return `${m}분`;
  if (m === 0) return `${h}시간`;
  return `${h}시간 ${m}분`;
}

/**
 * Format milliseconds as "H:MM" for CSV export (e.g. "8:00", "12:30").
 * 시간이 24를 넘어도 자르지 않는다 — 집계 기간 합계가 들어올 수 있다.
 */
export function formatDurationHHMM(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '0:00';
  const totalMinutes = Math.floor(ms / 60_000);
  return `${Math.floor(totalMinutes / 60)}:${String(totalMinutes % 60).padStart(2, '0')}`;
}
